import React from "react";
import styled from "styled-components";

interface ModalProps {
  show: boolean;
  children: JSX.Element | JSX.Element[];
  backgroundOpacity?: string;
}

const ModalBackground = styled("div")<{ opacity?: string }>`
  background-color: ${(props) =>
    props.opacity ? props.opacity : "rgba(0, 0, 0, 0.4)"};

  position: fixed; /* Sit on top of the page content */
  width: 100%; /* Full width (cover the whole page) */
  height: 100%; /* Full height (cover the whole page) */
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1; /* Specify a stack order in case you're using a different order for other elements */
`;

const ModalWrapper = styled.div`
  position: relative;
  z-index: 10;
`;

const ModalContentContainer = styled.div`
  overflow-y: auto;
  overflow-x: auto;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 10;
`;

const ModalFlexContainer = styled.div`
  display: flex;
  padding: 1rem;
  text-align: center;
  justify-content: center;
  align-items: flex-end;
  min-height: 100%;
  width: 100%;

  @media (min-width: 640px) {
    padding: 0;
    align-items: center;
  }
`;

export const Modal = React.forwardRef<HTMLDivElement, ModalProps>(
  ({ show, children, backgroundOpacity }, ref) => {
    if (!show) {
      return <></>;
    }
    return (
      <ModalWrapper>
        <ModalBackground opacity={backgroundOpacity} />

        <ModalContentContainer>
          <ModalFlexContainer>
                {children}
          </ModalFlexContainer>
        </ModalContentContainer>
      </ModalWrapper>
    );
  }
);
